import React, { useState } from 'react';

import { ChevronRightIcon, ChevronLeftIcon } from '@vlabs/icons';
import { BaseSample } from '@vlabs/shared/components/sample/BaseSample';
import { Control } from '@vlabs/uikit';
import cn from 'classnames';
import PropTypes from 'prop-types';

import st from './ImageSlider.module.sass';

export const ImageSlider = ({
  images = [],
  maxDotsLimit = 10,
  children = undefined,
  className = undefined,
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentDotIndex, setCurrentDotIndex] = useState(0);

  const isMaxDotsLimitOverflowed = images.length > maxDotsLimit;

  const onLeftClick = () => {
    if (currentDotIndex === 0) {
      if (currentImageIndex === 0) {
        setCurrentDotIndex(isMaxDotsLimitOverflowed ? maxDotsLimit - 1 : images.length - 1);
        setCurrentImageIndex(images.length - 1);
        return;
      }

      setCurrentImageIndex((prev) => prev - 1);
      return;
    }

    setCurrentDotIndex((prev) => prev - 1);
    setCurrentImageIndex((prev) => prev - 1);
  };

  const onRightClick = () => {
    if (currentDotIndex === (isMaxDotsLimitOverflowed ? maxDotsLimit - 1 : images.length - 1)) {
      if (currentImageIndex === images.length - 1) {
        setCurrentDotIndex(0);
        setCurrentImageIndex(0);
        return;
      }

      setCurrentImageIndex((prev) => prev + 1);
      return;
    }

    setCurrentDotIndex((prev) => prev + 1);
    setCurrentImageIndex((prev) => prev + 1);
  };

  const renderDots = () => {
    const dotsNumber = isMaxDotsLimitOverflowed ? 10 : images.length;
    const dots = [];

    for (let i = 0; i < dotsNumber; i++) {
      dots.push(
        <div
          className={cn(st.NavigationDot, { [st.NavigationDot_current]: i === currentDotIndex })}
          key={i}
        />);
    }

    return dots;
  };

  return (
    <div className={cn(st.Root, className)}>
      <div className={st.SampleContainer}>
        {!children && (
          <BaseSample
            className={st.Sample}
            data-testid="imageSlider.sample"
            emptyClassName={st.Sample_empty}
            imageUrl={images[currentImageIndex]}
            type="face"
          />
        )}

        {children && children?.(currentImageIndex)}
      </div>

      <div className={st.NavigationPanel}>
        <Control.IconButton
          data-testid="imageSlider.leftArrowButton"
          icon={<ChevronLeftIcon />}
          onClick={onLeftClick}
          size="small"
          variant="dimmed"
        />

        <div className={st.NavigationDotsList}>
          {renderDots()}
        </div>

        <Control.IconButton
          data-testid="imageSlider.rightArrowButton"
          icon={<ChevronRightIcon />}
          onClick={onRightClick}
          size="small"
          variant="dimmed"
        />
      </div>
    </div>
  );
};

ImageSlider.propTypes = {
  images: PropTypes.array,
  className: PropTypes.string,
  maxDotsLimit: PropTypes.number,
  children: PropTypes.node,
};
